import { render } from "./UserGroupUpdate.vue?vue&type=template&id=7394468e"
import script from "./UserGroupUpdate.vue?vue&type=script&lang=js"
export * from "./UserGroupUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__